import {
  // createAction,
  handleActions
} from "redux-actions";
import {
  getRangeOptions,
  getDateRanges,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom
} from "./../../../../../utils/date-range-options";
import {
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_MEMBERSHIP_ATTRITION_RATE_SUCCESS,
  FETCH_MEMBERSHIP_ACTIVITY_REVENUE_SUCCESS,
  FETCH_MEMBERSHIP_ACTIVITY_TOTALS_SUCCESS,
  FETCH_MEMBERSHIP_ACTIVITY_VALUES_SUCCESS,
  FETCH_SALES_ACTIVITY_REVENUE_SUCCESS,
  FETCH_INTROS_BOOKED_SUCCESS,
  FETCH_BAR_CHART_SUCCESS,
  SET_LOADING,
  SET_FILTERS_DIRTY,
  SET_DATES,
  UPDATE_CUSTOM_RANGE,
  UPDATE_DATES
} from "../sagas/studioInfo/studioInfo";
// Name Spaced Action Types
export const actions = {
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_MEMBERSHIP_ATTRITION_RATE_SUCCESS,
  FETCH_MEMBERSHIP_ACTIVITY_REVENUE_SUCCESS,
  FETCH_MEMBERSHIP_ACTIVITY_TOTALS_SUCCESS,
  FETCH_MEMBERSHIP_ACTIVITY_VALUES_SUCCESS,
  FETCH_SALES_ACTIVITY_REVENUE_SUCCESS,
  FETCH_INTROS_BOOKED_SUCCESS,
  FETCH_BAR_CHART_SUCCESS,
  SET_LOADING,
  SET_FILTERS_DIRTY,
  SET_DATES,
  UPDATE_CUSTOM_RANGE,
  UPDATE_DATES
};

// createAction is a lib for creating FSAs
// see https://github.com/acdlite/flux-standard-action, for info in the flux standard action
export const actionCreators = {};

export const initialState = {
  attritionRate: {},
  membershipActivityRevenue: { tableInfo: { data: [] } },
  membershipActivityTotals: {
    data: []
  },
  barChart: {
    metrics: [],
    data: []
  },
  membershipActivityValues: {},
  salesActivityRevenue: { tableInfo: { data: [] } },
  introsBooked: { data: {} },
  currentUser: {},
  selectedRequestDates: {},
  isLoading: true,
  filtersDirty: false,
  selectedRangeOption: {},
  rangeOptions: []
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload
    }),
    [FETCH_MEMBERSHIP_ATTRITION_RATE_SUCCESS]: (state, action) => ({
      ...state,
      attritionRate: action.payload
    }),
    [FETCH_MEMBERSHIP_ACTIVITY_REVENUE_SUCCESS]: (state, action) => ({
      ...state,
      membershipActivityRevenue: action.payload
    }),
    [FETCH_MEMBERSHIP_ACTIVITY_TOTALS_SUCCESS]: (state, action) => ({
      ...state,
      membershipActivityTotals: action.payload
    }),
    [FETCH_MEMBERSHIP_ACTIVITY_VALUES_SUCCESS]: (state, action) => ({
      ...state,
      membershipActivityValues: action.payload
    }),
    [FETCH_SALES_ACTIVITY_REVENUE_SUCCESS]: (state, action) => ({
      ...state,
      salesActivityRevenue: action.payload
    }),
    [FETCH_INTROS_BOOKED_SUCCESS]: (state, action) => ({
      ...state,
      introsBooked: action.payload
    }),
    [FETCH_BAR_CHART_SUCCESS]: (state, action) => ({
      ...state,
      barChart: action.payload
    }),
    [SET_DATES]: (state, action) => {
      const rangeOptions = getRangeOptions(
        action.payload.endDate,
        state.currentUser.calendarStartDate
      );
      return {
        ...state,
        selectedRequestDates: action.payload,
        rangeOptions: getRangeOptionsWithCustom(rangeOptions, action),
        selectedRangeOption: getSelectedRangeOptionWithCustom(action)
      };
    },
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload,
      selectedRequestDates: getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.currentUser.calendarStartDate
      ),
      filtersDirty: true
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action),
      filtersDirty: true
    })
  },
  initialState
);
